import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const PaypalPayment = () => {
  return <CommonProcess />;
};

export default PaypalPayment;
